export const defaultSettingBailiffSelector = (state) =>
  state?.defaultSettingReducer?.defaultSettingBailiff;
